import React from 'react'
import './get-notified.css'
function GetNotified() {
    return (
        <div className='get-notified'>
            <h2>Get notified</h2>
            <h4>Enter your name and email address</h4>
            <div className="get-notified__card">
                <div className="get-notified-input-group get-notified-first-name">
                    <label htmlFor="" className="get-notified-input-label">First Name</label>
                    <input type="text" name="firstName" id="firstName" className="get-notified-input" />
                </div>
                <div className="get-notified-input-group get-notified-last-name">
                    <label htmlFor="" className="get-notified-input-label">Last Name</label>
                    <input type="text" name="lastName" id="lastName" className="get-notified-input" />
                </div>
                <div className="get-notified-input-group get-notified-email">
                    <label htmlFor="" className="get-notified-input-label">Email</label>
                    <input type="text" name="emailAddress" id="emailAddress" className="get-notified-input" />
                </div>
                <div className='get-notified-waitlist'>
                    <button className="get-notified-btn" id='move-to-registration'>
                    Join the waitlist
                </button>
                </div>
            </div>
        </div>
    )
}

export default GetNotified